export const TABS = {
  FIINTRADE_RANKING: 1,
  ALL_SCORE: 2,
};

const listColumn = {
  organCode: 'organCode',
  rank: 'rank',
  ticker: 'ticker',
  industry: 'industry',
  rankingHistory: 'rankingHistory',
  ranking: 'ranking',
};

const listTabFilterAllScore = {
  all: 1,
  HOSE: 'HOSE',
  HNX: 'HNX',
};

const listTabsAllScore = [
  { key: listTabFilterAllScore.all, name: 'stRanking.tabChildrens.all' },
  { key: listTabFilterAllScore.HOSE, name: 'stRanking.tabChildrens.hose' },
  { key: listTabFilterAllScore.HNX, name: 'stRanking.tabChildrens.hnx' },
];

export default {
  listColumn,
  organCode: 'organCode',
  maxRowData: 10,
  TABS,
  industryId: 'VN30',
  pageSize: 50,
  listTabFilterAllScore,
  listTabsAllScore,
  icbCodeDefault: 'all',
};
